<template>
  <ButtonBase :class="$style.root" v-on="$listeners">
    <slot />
  </ButtonBase>
</template>
<script>

import ButtonBase from '../ButtonBase'

export default {
  name: 'IconButton',

  components: { ButtonBase }
}

</script>

<style module>

.root {
  line-height: 0;

  @apply p-2 rounded;
}

.root:focus,
.root:active {
  @apply outline-none;
}

.root:hover {
  @apply bg-dull-light;
}

.root:disabled {
  @apply bg-transparent;
}

.root:disabled > * {
  @apply text-dull;
}

</style>
